import _axios from "../../userCenter";
import qs from 'qs'

// 通过token获取用户信息.
export const apiMe = () =>
    _axios({
        url: "/me",
        method: "post"
    });

//退出登录
export const userLogout = () =>
    _axios({
        url: "/logout",
        method: "post"
    });

//修改密码
export const changePassword = data =>
    _axios({
        url: "/changePassword",
        method: "post",
        data: qs.stringify(data)
    });

//发送验证码
export const sendMsg = data =>
    _axios({
        url: "/sendMsg",
        method: "post",
        data: qs.stringify(data)
    });

//个人更换绑定手机号
export const phoneByAuthentication = data =>
    _axios({
        url: "/change/bind/phoneByAuthentication",
        method: "put",
        data
    });

//企业更换绑定手机号申请
export const changeBindApply = data =>
    _axios({
        url: "/change/bind/apply",
        method: "post",
        data
    });

export const bindCancelApply = data =>
    _axios({
        url: "/change/bind/cancel",
        method: "put",
        data
    });

//更新token
export const refreshToken = () =>
    _axios({
        url: "/refreshToken",
        method: "post",
    });

//获取企业换绑申请状态
export const getStatusByType = (type) =>
    _axios({
        url: `/change/bind/statusByType?type=${type}`,
        method: "get",
    });

//换绑邮箱验证手机号
export const verifyPhoneAuthentication = data =>
    _axios({
        url: "/verifyPhoneAuthentication",
        method: "post",
        data
    });


//个人更换绑定邮箱
export const emailByAuthentication = data =>
    _axios({
        url: "/change/bind/emailByAuthentication",
        method: "put",
        data
    });

//校验验证码
export const verifyCode = data =>
    _axios({
        url: "/verifyCode",
        method: "post",
        data
    });

//重置密码
export const recover = data =>
    _axios({
        url: "/recover",
        method: "post",
        data:qs.stringify(data)
    });